import { render, staticRenderFns } from "./topbarmenu.vue?vue&type=template&id=6d97207c&scoped=true&"
import script from "./topbarmenu.vue?vue&type=script&lang=ts&"
export * from "./topbarmenu.vue?vue&type=script&lang=ts&"
import style0 from "./topbarmenu.vue?vue&type=style&index=0&id=6d97207c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d97207c",
  null
  
)

export default component.exports